export const OffersConfig = {
  comboOffer: {
    enabled: true, // master switch to turn the offer on/off
    percentOff: 20, // discount percentage applied on subtotal
    // description shown in UI
    title: 'Limited Offer',
    description: 'Buy pack of 3 dose and get 20% off!'
  }
};


